import React from 'react';

import Suspense from '../../Common/components/Suspense-component';
import AddUser from '../component-add-user';

import localStorage from '../../Common/LocalStorage';
import { UserRole } from '../../Common/UserRole';
import { getUserStatus, getCompanyOfUser, getPharmacyOfUser } from '../epics-users';
import { getCompaniesList, getCompaniesListWhitoutOnwers, getPharmaciesForSingleCompany } from '../../Companies/epics-companies';
import { getPharmacyListWithoutManagers } from '../../Pharmacies/epics-pharmacies';

export class AddUserContainer extends React.Component {
    generateDeppendsOnRole = (role, specificRole, generalList, specificList) => {
        switch (role) {
            case specificRole:
                return specificList;
            case '':
                debugger;
                return [];
            default:
                return generalList;
        }
    };

    generateCompanyList = userRole => {
        switch (localStorage.getUsernameRole()) {
            case UserRole.ADMIN:
                return typeof userRole !== 'undefined'
                    ? this.generateDeppendsOnRole(userRole, UserRole.STORE_OWNER, getCompaniesList(), getCompaniesListWhitoutOnwers())
                    : [];
            case UserRole.STORE_OWNER:
                return getCompanyOfUser();
            case UserRole.PHARMACY_MANAGER:
                return getCompanyOfUser();
            default:
                return [];
        }
    };

    generatePharmacyList = (id, userRole) => {
        switch (localStorage.getUsernameRole()) {
            case UserRole.ADMIN:
                if (id !== '') {
                    return typeof userRole !== 'undefined'
                        ? this.generateDeppendsOnRole(
                              userRole,
                              UserRole.PHARMACY_MANAGER,
                              getPharmaciesForSingleCompany(id),
                              getPharmacyListWithoutManagers(id)
                          )
                        : [];
                } else {
                    return [];
                }
            case UserRole.STORE_OWNER:
                return id ? getPharmaciesForSingleCompany(id) : [];
            case UserRole.PHARMACY_MANAGER:
                return getPharmacyOfUser();
            default:
                return [];
        }
    };

    render() {
        return (
            <div>
                <Suspense
                    apiCalls={{
                        status: () => getUserStatus(),
                        companyList: userRole => this.generateCompanyList(userRole),
                        pharmacyList: (id, userRole) => this.generatePharmacyList(id, userRole)
                    }}
                >
                    <AddUser />
                </Suspense>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/customModules/Users/containers/container-add-user.js